/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".full-width-panel[_ngcontent-%COMP%]{position:relative;background:#edf6ff;height:100%;width:100%;padding:5px}.full-width-detail[_ngcontent-%COMP%]{padding-top:4px}.full-width-details[_ngcontent-%COMP%]{overflow-y:scroll;float:left;padding:5px;margin:5px;height:80%;width:100%}.full-width-grid[_ngcontent-%COMP%]{margin-left:150px;padding-top:25px;display:block;height:100%}"];
export { styles as styles };
